import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import AffiliationChangeForm from '../components/AffiliationChangeForm'
import { updateAffiliations, clearAffiliationMessages } from '../actions/profileActions'

class AffiliationChangeContainer extends Component {
  state = {
    affiliations: this.props.affiliations,
    invalidMessage: {}
  }

  componentWillUnmount = () => {
    this.props.clearAffiliationMessages()
  }

  handleChange = (event) => {
    event.persist()
    this.setState({ invalidMessage: [] })
    if (event.target.name.startsWith('ID')) {
      if (event.target.name.endsWith('FFPS')) {
        this.changeState(event.target.name.substring(2), { id: event.target.value.toLowerCase() })
      } else {
        this.changeState(event.target.name.substring(2), { id: event.target.value.replace(/(\D)*/g, '') })
      }
    } else if (event.target.name.startsWith('PIN')) {                                                                                   
      if(event.target.name.endsWith('FFPS')){
        this.changeState(event.target.name.substring(3), { pin: event.target.value })
      }else{
        this.changeState(event.target.name.substring(3), { pin: event.target.value.replace(/(\W)*/g, '') })
      }
    } else if (event.target.checked) {
      if (this.state.affiliations.some(a => a.name === event.target.value)) {
        this.changeState(event.target.value, { deleted: false })
      } else {
        this.setState(prevState => ({ affiliations: [...prevState.affiliations, { name: event.target.value, id: '', pin: '', deleted: false }] }))
      }
    } else if (!event.target.checked) {
      this.changeState(event.target.value, { deleted: true })
    }
  }

  changeState = (name, changes) => {
    let index = this.state.affiliations.findIndex(a => a.name === name)
    const affiliations = [...this.state.affiliations]
    affiliations[index] = { ...affiliations[index], ...changes }
    this.setState({ affiliations, invalidMessage: [] })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    if (!this.state.affiliations.some(aff => !aff.deleted)) {
      this.setState(prevState => ({
        invalidMessage: [...prevState.invalidMessage, 'invalid submit']
      }))
    } else {
      this.props.clearAffiliationMessages()
      this.props.updateAffiliations(this.state.affiliations, this.props.user.vaEauthSecId)
    }
  }

  handleReset = (event) => {
    event.preventDefault()
    this.props.clearAffiliationMessages()
    this.setState({ affiliations: this.props.affiliations, invalidMessage: [] })
  }

  handleInvalid = (event) => {
    event.preventDefault()
    event.persist()
    if (event.target.value === '') {
      this.setState(prevState => ({
        invalidMessage: { ...prevState.invalidMessage, [event.target.id]: 'Required' }
      }))
    } else if (event.target.id === 'Lender ID' || event.target.id === 'Servicer ID') {
      this.setState(prevState => ({
        invalidMessage: { ...prevState.invalidMessage, [event.target.id]: `${event.target.id} must be 10 digits long.` }
      }))
    }
  }

  render() {
    const { location, updateStatus } = this.props
    if (updateStatus.success && location.state) {
      return (
        <Redirect
          to={{
            pathname: location.state.referer,
            state: { referer: location.pathname, success: updateStatus.success }
          }}
        />
      )
    }

    return (
      <AffiliationChangeForm
        affiliations={this.props.affiliations}
        state={this.state}
        handleSubmit={this.handleSubmit}
        handleChange={this.handleChange}
        handleInvalid={this.handleInvalid}
        handleReset={this.handleReset}
        updateStatus={this.props.updateStatus}
        serverProperties={this.props.serverProperties} />)
  }
}

const mapStateToProps = (state) => ({
  updateStatus: state.profileInfo.updateUserAffiliations,
  affiliations: state.currentUser.affiliations ? state.currentUser.affiliations : [],
  user: state.currentUser,
  serverProperties : state.serverProperties
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ updateAffiliations, clearAffiliationMessages }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AffiliationChangeContainer)
